'use client'

import { Cell, Divider, Label, Spacer, Icon } from '@vinted/web-ui'
import { Flag24 } from '@vinted/monochrome-icons'

import { HelpCenterQuestionModel } from 'types/models/help-center'
import { generateFaqLink } from '_libs/utils/faq'
import { useLocation } from '@marketplace-web/shared/browser'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { SeparatedList } from '@marketplace-web/shared/ui-helpers'
import useHelpCenterSessionTracking from 'hooks/useHelpCenterSessionTracking'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { userClickRecommendedTopicEvent } from '_libs/common/event-tracker/events'

type RecommendedFaq = {
  id: number
  title: string
  path: string
}

type Props = {
  faqEntries: Array<HelpCenterQuestionModel>
}

const HelpCenterRecommendedFaqList = ({ faqEntries }: Props) => {
  const { access_channel, thread_id } = useLocation().searchParams
  const translate = useTranslate('help_center.recommended_faq_list')

  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  const renderFaqItem = ({ id, title }: RecommendedFaq) => (
    <Cell
      key={id}
      prefix={<Icon name={Flag24} color={Icon.Color.GreyscaleLevel3} />}
      title={title}
      type={Cell.Type.Navigating}
      url={generateFaqLink({ id, title }, access_channel, thread_id)}
      chevron
      testId={`help-center-recommended-faq-${id}`}
      onClick={() => track(userClickRecommendedTopicEvent({ helpCenterSessionId }))}
    />
  )

  return (
    <Cell styling={Cell.Styling.Tight}>
      <Label type={Label.Type.Stacked} text={translate('title')} />
      <Spacer size={Spacer.Size.Regular} />
      <SeparatedList separator={<Divider />}>{faqEntries.map(renderFaqItem)}</SeparatedList>
    </Cell>
  )
}

export default HelpCenterRecommendedFaqList
